<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getContactTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionContact && permissionContact.permission_id === permission.readWrite"
          @click.native="createContactData"/>
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center" v-for="header in headers" :key="header.id">
              {{ header.text }}
              <template v-if="header.icon">
                <a @click="sortDataTable(header.id)">
                  <v-icon class="fas fa-caret-down"
                          v-if="sort_date == 'desc'"
                          style="font-size: 12px"></v-icon>
                  <v-icon class="fas fa-caret-up"
                          v-if="sort_date == 'asc'"
                          style="font-size: 12px"></v-icon>
                </a>
              </template>
            </th>
          </tr>
          </thead>
          <tr v-for="(item,index) in dataTable" :key="index">
            <td width="5%" align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
            <td width="10%">{{item.branch ? item.branch.branch_name_en : ''}}</td>
            <td>{{item.mini_tcdc ? item.mini_tcdc.branch_name_en : ''}}</td>
            <td>{{item.description_en}}</td>
            <td width="15%" >{{item.contact_email}}</td>
            <td width="12%">{{item.updated_at | moment('DD-MM-YYYY')}}</td>
            <td width="5%" >
              <a @click="showContactData(item.id)">
                <icon-pencil />
              </a>
            </td>
          </tr>
          <tbody>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
    import InputSearch from "../../../components/Input/InputSearch";
    import CircleButton from "../../../components/Button/CircleButton";
    import IconPencil from "../../../components/Icon/icon-pencil";
    import Paginate from "../../../components/Layout/Paginate";
    import {permissionContact, role} from "../../../util/Permission";
    import Loading from 'vue-loading-overlay';
    import Swal from "sweetalert";

    export default {
        name: "ContactTable",
      components: {Paginate, IconPencil, CircleButton, InputSearch, Loading},
      computed:{
        permissionContact,
      },
      data() {
        return {
          title: "Contact",
          isLoading: false,
          headers: [
            { id: 1, text: "No." ,icon : null},
            { id: 11, text: "Branch" ,icon : true},
            { id: 3, text: "Mini TCDC" ,icon : null},
            { id: 4, text: "Description" ,icon : null},
            { id: 5, text: "E-mail" ,icon : null},
            { id: 22, text: "Update date" ,icon : true},
            { id: 7, text: "Edit" ,icon : null}
          ],
          dataTable: [],
          dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
          },
          permission : null,
          search : '',
          sort_branch : 'desc',
          sort_date : 'desc',
        };
      },
      created() {
          this.permission = role;
          this.getContactTable(1);
      },
      methods:{
        getContactTable(page){
          this.isLoading = true;
          this.$store.dispatch("Contact/getContact",{
            page,
            search : this.search,
            sort_date : this.sort_date,
            sort_branch : this.sort_branch,
          }).then(res=>{
            if(res.response_code == 200){
              this.dataTable = res.result.data;
              this.dataPaginate = {
                current_page: res.result.current_page,
                from: res.result.from,
                last_page: res.result.last_page,
                per_page: res.result.per_page,
                total: res.result.total,
                to: res.result.to
              }
            }
            this.isLoading = false;
          }).catch(()=>{
            Swal('','Cannot get contact data','error');
            this.isLoading = false;
          })
        },
        async changePage(val){
          this.isLoading = true;
          this.dataPaginate.current_page = val;
          await this.getContactTable(this.dataPaginate.current_page);
          this.isLoading = false;
        },
        goToContactEdit(){
          this.$router.push("/contact/edit");
        },
        showContactData(id){
          this.isLoading = true;
          this.$store.dispatch("Contact/showContact",id).then(res=>{
            if(res.response_code == 200){
              this.$store.dispatch("Contact/setFormContact",res.result).then(()=>{
                this.goToContactEdit();
              })
            }
            this.isLoading = false;
          }).catch(()=>{
            Swal('','Cannot get contact data','error');
            this.isLoading = false;
          });
        },
        createContactData(){
          this.$store.dispatch("Contact/clearFormData").then(()=>{
            this.goToContactEdit();
          });
        },
        searchInput(val){
          this.search = val;
        },
        sortDataTable(header_id){
          this.sort = this.sort == 'desc' ? 'asc' : 'desc';
          if(header_id === 11){ //sort by branch
            this.sort_branch = this.sort_branch == 'desc' ? 'asc' : 'desc';
          }
          if(header_id === 22){ //sort by updated_at
            this.sort_date = this.sort_date == 'desc' ? 'asc' : 'desc';
          }
          this.getContactTable(1);
        }

      }
    }
</script>

<style scoped>
  .branch-data {
    background-color: transparent;
    margin: 20px;
  }
</style>
